import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import fitty from 'fitty'
import { searchLightboxes } from '../components/search'

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default {
  init() {

    searchLightboxes()

    /**************************************************************
    -> Animate sticky when the right section is in the viewport
    **************************************************************/
    function fadeImages() {
      const images = Array.from(document.querySelectorAll('[data-image-id]'))
      const triggers = Array.from(document.querySelectorAll('[data-image-trigger]'))

      if (document.querySelector('.text')) {
        const textHeight = document.querySelector('.text').offsetHeight

        // Only have the images stick if the text column height is larger than the page.
        // This should indicate that there is some room to scroll, giving space to trigger

        // Update: Only have the images if the text doubles the viewport AND there are less than 12 images

        const textImagesRatio = textHeight / (images.length / 2)
        const minScrollHeight = window.innerHeight / 2 // 
        console.log(textImagesRatio)
        console.log(minScrollHeight)

        if (textImagesRatio > minScrollHeight) {

          triggers.forEach(trigger => {
            const id = trigger.dataset.imageTrigger

            if (id) {
              const thisImage = document.querySelector(`[data-image-id="${id}"]`)
              const filteredImages = images.filter(image => image.dataset.imageId !== id)

              ScrollTrigger.matchMedia({
                // desktop
                '(min-width: 1024px)': function () {
                  ScrollTrigger.create({
                    trigger: trigger,
                    start: '50% bottom',
                    end: 'center top',
                    onEnter: () => {
                      gsap.to(filteredImages, { duration: 0.3, opacity: 0, zIndex: 50 })
                      gsap.to(thisImage, { duration: 0.3, opacity: 1, zIndex: 100 })
                    },
                    onEnterBack: () => {
                      gsap.to(filteredImages, { duration: 0.3, opacity: 0, zIndex: 50 })
                      gsap.to(thisImage, { duration: 0.3, opacity: 1, zIndex: 100 })
                    },
                  });
                },
              })
            }

          })
        }
      }
    }

    fadeImages()

    /**************************************************************
    -> Manually navigate lightboxes via buttons
    **************************************************************/
    function lightboxNavButtons() {
      const lightboxes = Array.from(document.querySelectorAll('[data-lightbox-image]'))

      lightboxes.forEach(lightbox => {
        const nextArrows = Array.from(lightbox.querySelectorAll('[data-image-next]'))
        const prevArrows = Array.from(lightbox.querySelectorAll('[data-image-prev]'))

        nextArrows.forEach(arrow => {
          arrow.addEventListener('click', () => {
            const index = arrow.dataset.index
            const nextLightbox = lightboxes[parseInt(index) + 1]

            gsap.set(lightbox, { zIndex: 50 })
            gsap.set(nextLightbox, { zIndex: 100 })
            gsap.to(lightbox, { opacity: '0%', pointerEvents: 'none', ease: 'linear', duration: 0.5, delay: 0.5, zIndex: 50 })
            gsap.to(nextLightbox, { opacity: '100%', pointerEvents: 'all', ease: 'linear', duration: 0.5, zIndex: 100 })

            // Also need to change the sticky image (right side of the page) so that the correct
            // image shows when the lightbox is closed
            const thisImage = document.querySelector(`[data-image-id="${parseInt(index) + 1}"]`)
            const thumb = document.querySelector(`button.thumbnail[data-index="${parseInt(index) + 1}"]`)
            console.log(thumb)
            // const images = Array.from(document.querySelectorAll('button.thumbnail[data-index]'))
            // const filteredImages = images.filter(image => image.dataset.dataIndex !== index)
            // gsap.to(filteredImages, {duration: 0.5, opacity: 0, zIndex: 50})
            gsap.to(thisImage, { duration: 0.5, opacity: 1, zIndex: 100 })
            gsap.to(thumb, { duration: 0.3, opacity: 1, zIndex: 100 });

          })
        })

        prevArrows.forEach(arrow => {
          arrow.addEventListener('click', () => {
            const index = parseInt(arrow.dataset.index)
            const prevLightbox = lightboxes[index - 1]

            gsap.set(lightbox, { zIndex: 50 })
            gsap.set(prevLightbox, { zIndex: 100 })
            gsap.to(lightbox, { opacity: '0%', pointerEvents: 'none', ease: 'linear', duration: 0.5, delay: 0.5 })
            gsap.to(prevLightbox, { opacity: '100%', pointerEvents: 'all', ease: 'linear', duration: 0.5 })

            // Also need to change the sticky image (right side of the page) so that the correct
            // image shows when the lightbox is closed
            const thisImage = document.querySelector(`[data-image-id="${parseInt(index) - 1}"]`)
            const thumb = document.querySelector(`button.thumbnail[data-index="${parseInt(index) + 1}"]`)
            console.log(thumb)
            // const images = Array.from(document.querySelectorAll('button.thumbnail[data-index]'))
            // const filteredImages = images.filter(image => image.dataset.dataIndex !== toString(index - 1))
            // gsap.to(filteredImages, {duration: 0.3, opacity: 0, zIndex: 50})
            gsap.to(thisImage, { duration: 0.3, opacity: 1, zIndex: 100 })
            gsap.to(thumb, { duration: 0.3, opacity: 1, zIndex: 100 });
          })
        })
      })
    }

    lightboxNavButtons()

    /**************************************************************
    -> Manually navigate images via buttons
    **************************************************************/
    function imageNavButtons() {
      const images = Array.from(document.querySelectorAll('.images figure'))

      images.forEach(image => {
        const nextArrows = Array.from(image.querySelectorAll('[data-image-next]'))
        const prevArrows = Array.from(image.querySelectorAll('[data-image-prev]'))

        nextArrows.forEach(arrow => {
          arrow.addEventListener('click', () => {
            const index = arrow.dataset.index
            const nextImage = images[parseInt(index) + 1]

            gsap.to(image, { duration: 0.3, opacity: 0, zIndex: 50 })
            gsap.to(nextImage, { duration: 0.3, opacity: 1, zIndex: 100 })
          })
        })

        prevArrows.forEach(arrow => {
          arrow.addEventListener('click', () => {
            const index = arrow.dataset.index
            const prevImage = images[parseInt(index) - 1]

            gsap.to(image, { duration: 0.3, opacity: 0, zIndex: 50 })
            gsap.to(prevImage, { duration: 0.3, opacity: 1, zIndex: 100 })
          })
        })
      })
    }

    imageNavButtons()

    /**************************************************************
    -> Show/hide lightbox UI on mouse move
    **************************************************************/
    function showHideImageUi() {
      let timeout
      let isHidden = true
      const imageLightboxesForHover = Array.from(document.querySelectorAll('[data-lightbox-image]'))

      // Make UI always visible on mobile
      if (window.innerWidth <= 768) {
        imageLightboxesForHover.forEach(lightbox => {
          const ui = lightbox.querySelector('.image-ui')
          ui.classList.remove('opacity-0')
          ui.classList.add('opacity-100')
          ui.style.opacity = 1
        })
      } else {
        imageLightboxesForHover.forEach(lightbox => {
          const ui = lightbox.querySelector('.image-ui')
          lightbox.addEventListener('mousemove', () => {

            gsap.to(ui, { opacity: 1 })

            if (timeout) {
              clearTimeout(timeout)
            }

            timeout = setTimeout(() => {
              if (!isHidden) {
                gsap.to(ui, { opacity: 0 })
                isHidden = true
              }
            }, 1500)

            if (isHidden) {
              gsap.to(ui, { opacity: 1 })
              isHidden = false
            }
          })
        })
      }
    }

    showHideImageUi()

    window.addEventListener('resize', () => {
      showHideImageUi()
    })

    /**************************************************************
    -> Launch image lightbox when expand button is clicked
    **************************************************************/
    function imageLightboxes() {

      const buttons = Array.from(document.querySelectorAll('[data-button-expand]'))

      if (buttons) {

        buttons.forEach(button => {
          const id = button.dataset.buttonId
          const lightbox = document.querySelector(`[data-lightbox-image][data-index="${id}"]`)
          const close = lightbox.querySelector('[data-button-contract]')
          const mobileReadMore = lightbox.querySelector('.mobile-more')
          const mobileReadLess = lightbox.querySelector('.mobile-less')
          const mobileFullscreenCaption = lightbox.querySelector('.caption-full-mobile')

          button.addEventListener('click', () => {
            document.body.style.overflow = 'hidden'
            gsap.to(lightbox, { opacity: '100%', pointerEvents: 'all', zIndex: 100 })
          })

          close.addEventListener('click', () => {
            document.body.style.overflow = 'initial'
            gsap.to(lightbox, { opacity: '0%', pointerEvents: 'none', zIndex: 50 })
          })

          mobileReadMore.addEventListener('click', () => {
            gsap.to(mobileFullscreenCaption, { opacity: '100%', pointerEvents: 'all' })
          })

          mobileReadLess.addEventListener('click', () => {
            gsap.to(mobileFullscreenCaption, { opacity: '0%', pointerEvents: 'none' })
          })

        });

      }

    }

    imageLightboxes()

    /**************************************************************
    -> Expand image captions on hover
    **************************************************************/
    const captions = Array.from(document.querySelectorAll('.caption'))

    captions.forEach(caption => {
      let openState = false
      const short = caption.querySelector('.caption-short')
      const full = caption.querySelector('.caption-full')

      caption.addEventListener('click', () => {
        if (window.innerWidth >= 1024) {
          if (openState === false) {
            short.classList.add('hidden')
            full.classList.remove('hidden')
            openState = true
          } else {
            short.classList.remove('hidden')
            full.classList.add('hidden')
            openState = false
          }
        }
      })
    })

    /**************************************************************
    -> Scroll user down to intro section
    **************************************************************/
    function exploreButtonScroll() {
      const scrollButton = document.querySelector('.explore-button')

      if (scrollButton) {
        const nav = document.querySelector('.period-nav')

        scrollButton.addEventListener('click', () => {
          gsap.to(window, { scrollTo: { y: nav }, duration: 2, ease: 'power2.inOut', overwrite: true });
        })
      }
    }

    exploreButtonScroll()

    /**************************************************************
    -> Set light/dark no page load
    -> This defaults to dark mode if no preference has been set
    -> explicitly (via the light/dark switcher button)
    **************************************************************/
    // if (localStorage.theme === 'dark' || !localStorage.theme) {
    //   document.documentElement.classList.add('dark')
    // } else {
    //   document.documentElement.classList.remove('dark')
    // }

    /**************************************************************
    -> Light/dark mode switch
    **************************************************************/
    function colourModeSwitch() {
      const buttons = Array.from(document.querySelectorAll('.color-mode-switch'))

      buttons.forEach(button => {

        button.addEventListener('click', () => {

          // Check if a colour preference is set
          if (localStorage.theme === 'dark') {
            localStorage.theme = 'light'
            document.documentElement.classList.remove('dark')
          } else if (localStorage.theme === 'light') {
            localStorage.theme = 'dark'
            document.documentElement.classList.add('dark')
          } else {
            localStorage.theme = 'light'
            document.documentElement.classList.remove('dark')
          }

        })
      })

    }

    colourModeSwitch()

    /**************************************************************
    -> Intro hover animation
    **************************************************************/
    function introHoverAnimation() {
      const nextLink = document.querySelector('.next-link')
      const previousLink = document.querySelector('.previous-link')
      const exploreButton = document.querySelector('.explore-button')

      if (nextLink) {
        const nextImage = document.querySelector('.next-image img')
        const nextLinkText = document.querySelector('.next-link-text')
        const nextIcon = document.querySelector('.next-icon')

        nextLink.addEventListener('mouseenter', () => {
          if (window.innerWidth > 1024) {
            gsap.to(nextImage, { opacity: 1, duration: 0.3 })
            gsap.to(nextLinkText, { y: '-3vh', duration: 0.3, ease: 'power2.out' })
            gsap.to(nextIcon, { scale: 1.1, duration: 0.3, ease: 'power2.out' })
          }
        })

        nextLink.addEventListener('mouseleave', () => {
          gsap.to(nextImage, { opacity: 0, duration: 0.3 })
          gsap.to(nextLinkText, { y: '0', duration: 0.3, ease: 'power3.in' })
          gsap.to(nextIcon, { scale: 1, duration: 0.3, ease: 'power2.out' })
        })
      }

      if (previousLink) {
        const previousImage = document.querySelector('.previous-image img')
        const previousLinkText = document.querySelector('.previous-link-text')
        const previousIcon = document.querySelector('.previous-icon')

        previousLink.addEventListener('mouseenter', () => {
          if (window.innerWidth > 1024) {
            gsap.to(previousImage, { opacity: 1, duration: 0.3 })
            gsap.to(previousLinkText, { y: '-3vh', duration: 0.3, ease: 'power2.out' })
            gsap.to(previousIcon, { scale: 1.1, duration: 0.3, ease: 'power2.out' })
          }
        })

        previousLink.addEventListener('mouseleave', () => {
          gsap.to(previousImage, { opacity: 0, duration: 0.3 })
          gsap.to(previousLinkText, { y: '0', duration: 0.3, ease: 'power3.in' })
          gsap.to(previousIcon, { scale: 1, duration: 0.3, ease: 'power2.out' })
        })
      }

      if (exploreButton) {
        const selectPeriodText = document.querySelector('.select-period')
        const header = document.querySelector('.intro-header')
        const exploreText = document.querySelector('.explore-text')
        const icon = document.querySelector('.explore-button svg')
        const iconArrow = document.querySelector('.explore-button #arrow')

        exploreButton.addEventListener('mouseenter', () => {
          if (window.innerWidth > 1024) {
            gsap.to(selectPeriodText, { y: '-6vh', duration: 0.3, ease: 'power2.out' })
            gsap.to(header, { y: '-5vh', duration: 0.3, ease: 'power2.out' })
            gsap.to(exploreText, { y: '3rem', duration: 0.3, ease: 'power2.out' })
            gsap.to(icon, { scale: 1.05, duration: 0.3, ease: 'power2.out' })
            gsap.to(iconArrow, { yPercent: 15, duration: 0.3, ease: 'power2.out' })
          }
        })

        exploreButton.addEventListener('mouseleave', () => {
          gsap.to(selectPeriodText, { y: '0', duration: 0.3, ease: 'power2.out' })
          gsap.to(header, { y: '0', duration: 0.3, ease: 'power2.out' })
          gsap.to(exploreText, { y: '0', duration: 0.3, ease: 'power2.out' })
          gsap.to(icon, { scale: 1, duration: 0.3, ease: 'power2.out' })
          gsap.to(iconArrow, { yPercent: 0, duration: 0.3, ease: 'power2.out' })
        })
      }

    }

    introHoverAnimation()

    /**************************************************************
    -> Resize image lightbox to better VH units on mobile
    **************************************************************/
    function lightboxSizingMobile() {
      if (window.innerHeight < 769) {
        const lightboxes = Array.from(document.querySelectorAll('[data-lightbox-image]'))

        lightboxes.forEach(lightbox => {
          lightbox.style.height = 'calc(var(--vh, 1vh) * 100)'
        });
      }
    }

    lightboxSizingMobile()

    window.addEventListener('resize', () => {
      lightboxSizingMobile()
    })

    /**************************************************************
    -> Fit heading text on one line
    **************************************************************/
    fitty('.intro-header', {
      multiLine: true,
      maxSize: 140,
      minSize: 30,
    })

    /**************************************************************
    -> Fit heading text on one line
    **************************************************************/
    function imageZoom() {
      const lightboxes = Array.from(document.querySelectorAll('[data-lightbox-image] figure'))
      let mouseX = 0
      let mouseY = 0

      document.addEventListener('mousemove', (e) => {
        mouseX = e.x
        mouseY = e.y
      });

      lightboxes.forEach(lightbox => {
        const zoomButton = lightbox.querySelector('[data-button-zoom]')
        const zoomInIcon = zoomButton.querySelector('.icon-zoom-in')
        const zoomOutIcon = zoomButton.querySelector('.icon-zoom-out')
        const image = lightbox.querySelector('.image-container img')

        zoomButton.addEventListener('click', () => {

          if (zoomButton.dataset.zoomState === 'out') {
            zoomButton.dataset.zoomState = 'in'
            gsap.to(zoomInIcon, { opacity: 0 })
            gsap.to(zoomOutIcon, { opacity: 1 })
            image.style.zoom = '2';
            image.style.objectFit = 'none'
          } else {
            zoomButton.dataset.zoomState = 'out'
            gsap.to(zoomInIcon, { opacity: 1 })
            gsap.to(zoomOutIcon, { opacity: 0 })
            image.style.zoom = '1';
            image.style.objectPosition = '0% 0%';
            image.style.objectFit = 'cover'
          }
        })

        lightbox.addEventListener('mousemove', () => {
          if (zoomButton.dataset.zoomState === 'in') {
            const xPos = mouseX / lightbox.offsetWidth * 100
            const yPos = mouseY / lightbox.offsetHeight * 100
            image.style.objectPosition = `${xPos}% ${yPos}%`;
          }
        })
      });
    }

    imageZoom()


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-gemstone-chapters.js